export const dateFormatBR = (value) => {
  return Intl.DateTimeFormat("pt-BR").format(new Date(value));
};

export const dateFormatSQL = (value) => {
  return new Date(value).toISOString().split("T")[0];
};

export const formatDate = (value) => {
  if (!value) return '-';
  
  const date = new Date(value);
  const months = [
    'jan', 'fev', 'mar', 'abr', 'mai', 'jun',
    'jul', 'ago', 'set', 'out', 'nov', 'dez'
  ];
  
  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  
  return `${day} ${month} ${year} • ${hours}h${minutes}`;
};

export const allMonths = [
  "Janeiro",
  "Fevereiro",
  "Março",
  "Abril",
  "Maio",
  "Junho",
  "Julho",
  "Agosto",
  "Setembro",
  "Outubro",
  "Novembro",
  "Dezembro",
];
